<template>
  <section class="copyright">
    <div class="container">
      <div class="content">
        <div class="social">
          <a href="https://facebook.com"> <i class="fab fa-facebook-f"></i></a>
          <a href="https://instagram.com"> <i class="fab fa-instagram"></i></a>
          <a href="https://twitter.com/"> <i class="fab fa-twitter"></i></a>
          <a href="https://wa.me/201065740616">
            <i class="fab fa-whatsapp"></i
          ></a>
        </div>
        <div class="text">
          <p>جميع الحقوق محفوظة ل <span>بنك الدم </span> &#x24B8; 2019</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>
